<template>
  <div>
    <!-- 面包区 -->
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item><a href="/orgList">合作社列表</a></el-breadcrumb-item>
    </el-breadcrumb>
  <!-- 卡片区 -->
  <el-card>
    <el-row>
      <el-col :span="7">
        <el-input placeholder="请输入内容" v-model="orgFromData.orgName" class="input-with-select">
          <el-select v-model="select" slot="prepend" placeholder="请选择"></el-select>
          <el-button slot="append" icon="el-icon-search" @click="getOrg(1)"></el-button>
        </el-input>
      </el-col>
      <el-col :span="4"></el-col>
      <el-col :span="2">
        <el-button type="primary" plain @click="getOrg(1)">刷新数据</el-button>
      </el-col>
    </el-row>
  <!-- 合作社列表 -->
  <el-table
    :data="orgData"
    style="width: 100%"
    :row-class-name="tableRowClassName"
    border stripe>
    <el-table-column type="index"></el-table-column>
    <el-table-column
      prop="name"
      label="合作社名称"
      width="180">
    </el-table-column>
    <el-table-column
      prop="bal"
      label="预计农业银行余额"
      width="180">
    </el-table-column>
    <el-table-column
      prop="address"
      label="地址">
    </el-table-column>
    <el-table-column
      label="剩余可用预算">
      <template slot-scope="scope">
        <span>{{ scope.row.budget - scope.row.financialBudget }}</span>
      </template>
    </el-table-column>
    <el-table-column
      prop="loanAmount"
      label="剩余贷款额度">
      <template slot-scope="scope">
        <span>{{ scope.row.loanAmount - scope.row.financialLoanAmount }}</span>
      </template>
    </el-table-column>
    <el-table-column label="操作">
      <template slot-scope="scope">
        <el-tooltip :enterable="false" class="item" effect="dark" content="查看合作社流水" placement="top">
            <el-button size="mini" type="primary" icon="el-icon-share" @click="getRunningWater(scope.row.id)" >支付记录</el-button>
        </el-tooltip>
      </template>
    </el-table-column>
  </el-table>
  </el-card>
  <!-- 分页区域 -->
  <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryInfo.pagenum"
        :page-sizes="[2, 3, 5, 8, 10, 20]"
        :page-size="queryInfo.pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="queryInfo.total">
      </el-pagination>
  </div>
</template>

<script>
import { getSubORGListByFI } from '@/api/user'
export default {
  data () {
    return {
      orgDatax: [],
      orgData: [],
      orgFromData: {
        FIId: '',
        orgName: '',
        count: 10,
        offset: 0
      },
      queryInfo: {
        query: '',
        // 当前的页数
        pagenum: 1,
        pagesize: 5,
        total: 0
      }/* ,
      total: 0 */
    }
  },
  methods: {
    getOrg (key) {
      debugger
      // 点击刷新和搜索按键时对页码和查询起始页进行重置
      if (key === 1) {
        this.queryInfo.pagenum = 1
        this.orgFromData.offset = 0
      }
      this.orgData = []
      this.tableLoading = true
      getSubORGListByFI(this.orgFromData).then(res => {
        this.tableLoading = false
        debugger
        if (this.orgFromData.offset === 0) this.queryInfo.total = res.data.c.total
        this.orgData = res.data.c.data
        localStorage.setItem('orgData', JSON.stringify(this.orgData))
      })
    },
    // 监听每页显示条数的事件
    handleSizeChange (newSize) {
      this.queryInfo.pagesize = newSize
      this.orgFromData.count = newSize
      this.orgFromData.offset = (this.queryInfo.pagenum - 1) * newSize
      this.getOrg()
    },
    // 监听选择了第几页的事件
    handleCurrentChange (newPage) {
      this.queryInfo.pagenum = newPage
      this.orgFromData.count = this.queryInfo.pagesize
      this.orgFromData.offset = this.queryInfo.pagesize * (newPage - 1)
      this.getOrg()
    },
    // 前往审批列表页
    getRunningWater (id) {
      localStorage.setItem('setOrgId', JSON.stringify(id))
      // 对合作社列表进行缓存，方便下次进入时直接到对应的页码
      localStorage.setItem('orgListFYHC', JSON.stringify(this.queryInfo))
      this.$router.push('/paymentExamine')
    }
  },
  created () {
    debugger
    // 读取缓存的页码数据
    const orgListFYHC = JSON.parse(localStorage.getItem('orgListFYHC'))
    if (orgListFYHC !== null) {
      this.queryInfo = orgListFYHC // 将缓存页码赋值给queryInfo
      // 将每页请求条数赋值给准备提交表单数据orgFromData
      this.orgFromData.count = this.queryInfo.pagesize
      this.orgFromData.offset = this.queryInfo.pagesize * (this.queryInfo.pagenum - 1)
    }
    // 读取缓存的金融机构Id
    const orgFromDatax = JSON.parse(localStorage.getItem('orgFromData'))
    this.orgFromData.FIId = orgFromDatax.FIId
    this.getOrg()
  }
}
</script>

<style lang="less" scoped>
  .el-table{
    top: 0.625rem;
  }
</style>
